import "core-js/modules/es6.regexp.split";
export default function getVariation(placement) {
  return placement.split('-')[1];
}